import React, { useState } from "react";
import { useTranslation } from "../../../../hooks/useTranslation";

// Sample data
const data = {
  Hotels: [
    { id: 1, name: "Grand Hotel", bookings: 100, charges: 4000 },
    { id: 2, name: "Ocean View", bookings: 150, charges: 6000 },
    { id: 3, name: "Mountain Retreat", bookings: 150, charges: 5000 },
  ],
  Restaurants: [
    { id: 1, name: "Sunset Grill", bookings: 80, charges: 3000 },
    { id: 2, name: "Urban Dine", bookings: 120, charges: 4500 },
  ],
};

const CommissionPanel = () => {
  const { t } = useTranslation();
  const [category, setCategory] = useState("Hotels");
  const [selectedId, setSelectedId] = useState("");

  const items = data[category];
  const selectedItem = items.find((item) => item.id === parseInt(selectedId));

  const totalRegistered = items.length;
  const totalBooked = selectedItem
    ? selectedItem.bookings
    : items.reduce((sum, i) => sum + i.bookings, 0);
  const totalCharges = selectedItem
    ? selectedItem.charges
    : items.reduce((sum, i) => sum + i.charges, 0);
  const commissionRate = 0.08;
  const totalEarnings = totalCharges * commissionRate;

  return (
    <div>
      <div className="flex flex-wrap justify-between items-center  gap-[10px] mb-[16px]">
        <h2 className="2xl:text-lg text-base font-medium text-black">
          {t("admindashboard").Commission}
        </h2>
        {/* Category toggle */}
        <div style={{ marginBottom: "" }} className="justify-end text-right">
          <select
            className="text-[#7C7C7C] text-[15px] focus:outline-none pr-[30px]"
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
              setSelectedId(""); // Reset selection
            }}
          >
            <option value="Hotels">{t("admindashboard").hotel}</option>
            <option value="Restaurants">
              {t("admindashboard").restaurant}
            </option>
          </select>
        </div>
      </div>

      {/* Entity selector */}
      <div className="mb-[16px]">
        <select
          className="focus:outline-none focus:border-[#4CAF50]"
          id="entity-select"
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          style={{
            padding: "15px 11px",
            width: "100%",
            borderRadius: "5px",
            border: "1px solid #DDDDDD",
          }}
        >
          <option value="">
            {t("admindashboard").all.replace("{{category}}", category)}
          </option>
          {items.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      {/* Stats */}
      <div className="flex flex-col gap-[16px] text-[#18181B]  text-base">
        <div className="flex justify-between items-center">
          <p>
            {t("admindashboard").totalRegistered.replace(
              "{{category}}",
              category
            )}
          </p>{" "}
          <span className="text-right">{totalRegistered}</span>
        </div>
        <div className="flex justify-between items-center">
          <p>
            {t("admindashboard").totalBooked.replace(
              "{{categorySingular}}",
              category.slice(0, -1)
            )}
          </p>
          <span>{totalBooked}</span>
        </div>
        <div className="flex justify-between items-center">
          <p>
            {" "}
            {t("admindashboard").totalCharges.replace(
              "{{categorySingular}}",
              category.slice(0, -1)
            )}
          </p>
          <span>₾{totalCharges.toLocaleString()}</span>
        </div>
        <div className="flex justify-between items-center">
          <p>{t("admindashboard").commissionRate}: </p>{" "}
          <span>{commissionRate * 100}%</span>
        </div>
        <div className="flex justify-between items-center font-semibold">
          <p>
            {t("admindashboard").totalEarnings.replace(
              "{{category}}",
              category
            )}
          </p>

          <span>₾{totalEarnings.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default CommissionPanel;
